'use strict';

module.exports = {
  solid: [[], 0],
  dot: [[0.5, 1], 200],
  dash: [[0.5, 1], 50],
  longdash: [[0.5, 1], 10],
  dashdot: [[0.5, 0.625, 0.875, 1], 50],
  longdashdot: [[0.5, 0.7, 0.8, 1], 10]
};